import React from "react"

export const productSchema = (
  <script
    type="application/ld+json"
    key="product-schema"
    dangerouslySetInnerHTML={{
      __html: `{
        "@context" : "http://schema.org",
        "@type" : "Product",
        "brand" : {
          "@type": "Thing",
          "name": "CitizenShipper"
        },
        "name": "Shipping Service",
        "image" : "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg",
        "description" : "Looking for a reliable pet transportation service that provides all the creature comforts your furry friend deserves?<BR/><BR/>CitizenShipper connects you with vetted, experienced, animal-loving transporters who take the worry out of moving your pets across town or across the country",
        "aggregateRating" : {
          "@type" : "AggregateRating",
          "name" : "Shipping service",
          "ratingValue" : "5",
          "ratingCount" : "13431",
          "itemReviewed" : {
            "@type":"Service",
            "name":"Service"
          }
        },
        "review" : [ {
          "@type" : "Review",
          "author" : {
            "@type" : "Person",
            "name" : "Patrick McGuire"
          },
          "reviewBody" : "Easy to use mac's shipping is the best shipper",
          "itemReviewed" : {
            "@type":"Service",
            "name":"Service"
          }
        }, {
          "@type" : "Review",
          "author" : {
            "@type" : "Person",
            "name" : "Eleanor Preston"
          },
          "reviewBody" : "Really appreciated the sheer AMOUNT of transporters on this site to choose from - they made the selection easy, and the communication a breeze. will be recommending to all my friends / family.",
          "itemReviewed" : {
            "@type":"Service",
            "name":"Service"
          }
        }, {
          "@type" : "Review",
          "author" : {
            "@type" : "Person",
            "name" : "Ali Flihan"
          },
          "reviewBody" : "I really like CitizenShipper because i can ship anything by them and its easy to use. I shipped my Jetski from Kansas to Iowa. I would use them again and again for anything i want to ship.",
          "itemReviewed" : {
            "@type":"Service",
            "name":"Service"
          }
        } ]
      }
       `,
    }}
  />
)
export const homeSchema = (
  <script
    type="application/ld+json"
    key="home-schema"
    dangerouslySetInnerHTML={{
      __html: `{
  "@context": "https://schema.org/",
  "@type": "Organization",
  "url": "https://citizenshipper.com/",
  "logo": "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg",
  "name": "Citizenshipper",
  "alternateName": "Citizenshipper LLC",
  "email": "support@citizenshipper.com",
  "description": "CitizenShipper is the safest, simplest way to transport anything, anywhere in the US. Connect with a fleet of screened drivers for a stress-free experience. Get free quotes, then pick the best option for your budget and schedule. From dogs, cars, boats, dirt bikes, rv trailers to furniture, we do it all.",
  "address": {
    "@type": "PostalAddress",
    "postalCode": "78702",
    "streetAddress": "701 Tillery Street Unit 12-1249",
    "addressCountry": "US",
    "addressRegion": "Texas",
    "addressLocality": "Austin"
  },
  "areaServed": {
    "@type": "GeoShape",
    "addressCountry": {
      "@type": "Country",
      "name": "US"
    }
  },
  "sameAs": [
    "https://www.facebook.com/CitizenShipperLLC",
    "https://www.instagram.com/citizenshipper/",
    "https://www.linkedin.com/company/citizenshipper",
    "https://www.youtube.com/@citizenshipper",
    "https://en.wikipedia.org/wiki/CitizenShipper",
    "https://citizenshipper.com/",
    "https://x.com/CitizenShipper",
    "https://www.tiktok.com/@citizen.shipper",
    "https://www.pinterest.com/citizenshipper/"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "telephone": "",
    "email": "support@citizenshipper.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "7879"
  },
  "foundingDate": "2008",
  "founder": {
    "@type": "Person",
    "name": "Richard Obousy"
  },
  "legalName": "Citizenshipper",
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Jeff Goldman"
      },
      "itemReviewed": {
        "@type": "Organization",
        "name": "CitizenShipper"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "datePublished": "",
      "url": "https://goo.gl/maps/VxWppjJi47XiHhp17",
      "publisher": {
        "@type": "Organization",
        "name": "Google"
      },
      "reviewBody": "I used Citizen Shipper to find an air nanny to deliver my new puppy from San Antonio Texas to Boston and it was a great experience. within minutes I received about 20 bids and I located my Nanny, Darby. I liked being able to read the reviews and see the profiles of the shippers. really was a great experience overall. Very cool to have such a reliable service bringing people and their puppies together."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Mary Ann Petek"
      },
      "itemReviewed": {
        "@type": "Organization",
        "name": "CitizenShipper"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "datePublished": "",
      "url": "https://goo.gl/maps/pzgWjZNkh75jRfPh9",
      "publisher": {
        "@type": "Organization",
        "name": "Google"
      },
      "reviewBody": "This site is not just for delivering pets!  I used them to pick up a set of moose antlers from an ebay seller who was located out of state. The courier was Purple Pup via Citizenshipper and the individual I dealt with was very responsive, and very courtious, and the moose antlers were delivered undamaged, and on time."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Brian"
      },
      "itemReviewed": {
        "@type": "Organization",
        "name": "CitizenShipper"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5"
      },
      "datePublished": "",
      "url": "https://trstp.lt/K_9oUSBDf",
      "publisher": {
        "@type": "Organization",
        "name": "TrustPilot"
      },
      "reviewBody": "This was my first time ever using a transport site/business and I never knew how affordable, dependable and easy it could be! Citizen shipper provides the platform in which you can pick the right company at the right price that fits your needs. I couldn’t believe how efficient everything went and I received a better deal than I ever expected with my shipment arriving right on time! Incredibly satisfied customer here and I will most definitely return here with any future needs! Exceptional."
    }
  ]
}
`,
    }}
  />
)
export const faqNewSchema = [
  <script
    type="application/ld+json"
    key="faq-schema"
    dangerouslySetInnerHTML={{
      __html: `{"@context":"https://schema.org/","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"How does CitizenShipper work, exactly?","acceptedAnswer":{"@type":"Answer","text":"CitizenShipper's online marketplace allows you to choose your transporter based on the quotes you receive. Just list your transport requirements, detailing the type of delivery, the destination, the preferred time frame, etc. We send this info out to the transporters best qualified to meet your requirements. You can then sit back, relax, and wait for the quotes from matching transporters to come in before choosing the best offer."}},{"@type":"Question","name":"How and when do I pay for the shipment?","acceptedAnswer":{"@type":"Answer","text":"CitizenShipper does not mediate the transactions between you and your transporter. Using our internal messaging system, you can discuss payment options safely and swiftly.  Transporters typically require full payment upon delivery, though some may ask for an upfront payment in part or in whole. Payments can be made via cash, check, or credit card; some transporters also accept Venmo and Apple Pay.  If transporters require you to pay upfront, we recommend using only payment processors that allow chargebacks (credit cards, PayPal, etc.) Avoid using direct money transfers (Moneygram, Western Union, etc) for upfront payments. Those are irreversible and wouldn't allow you to dispute a payment."}},{"@type":"Question","name":"Is my pet kept safe during transportation?","acceptedAnswer":{"@type":"Answer","text":"Maintaining the safety of pets in transport is our number one priority. Transporters go through an extensive background screening process, which guarantees that only reliable, competent, qualified operators can contact you. Check for the Background Certified badge on a driver's profile."}},{"@type":"Question","name":"How much do you charge?","acceptedAnswer":{"@type":"Answer","text":"Listing your transportation requirements is completely free of charge. There's no “listing fee” required to gain access to the transporters and negotiate the shipping cost with them.  Once you accept a bid that best matches your requirements, we charge a percentage of the price that you and the transporter have agreed upon.  This works on a sliding scale with the exact numbers illustrated here."}},{"@type":"Question","name":"What should I expect after my listing goes live?","acceptedAnswer":{"@type":"Answer","text":"Once you list your transportation requirements, the transporters will start sending their quotes using our messaging system. The first messages should arrive within a few minutes if your shipment is listed in a high-traffic area. Otherwise, it might take a couple of hours for a transporter to get in touch.  You can answer these messages at your convenience, negotiate the price and all other details with the transporter. These exchanges are kept on record, assuring full safety and transparency."}}]}`,
    }}
  />,
  <script
    type="application/ld+json"
    key="faq-schema-breadcrumbs"
    dangerouslySetInnerHTML={{
      __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Frequently Asked Questions",
            "item": "https://citizenshipper.com/faq"
          }]
        }`,
    }}
  />,
]

export const faqSchema = (
  <script
    key="faq-schema"
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: `{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
          "@type": "Question",
          "name": "What is CitizenShipper and how does it work?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "CitizenShipper is an online marketplace where people with something to ship connect with individuals willing and able to complete the transport. Once you register as an independent transporter in the CitizenShipper community, instant access is granted to shipments listed by our customers. You are notified immediately of all the shipments we think you may be interested in, based on your put criteria, allowing you to provide quotes to customers. As you win bids and complete shipments, you earn positive feedback and improve your online profile and reputation."
          }
        }, {
          "@type": "Question",
          "name": "What do I need to get started?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "All you need is a driver’s license and vehicle insurance. After registering, you’ll also need to pass a background check, that CitizenShipper pays for, before you can officially book your first shipment. (We screen for felony convictions, DUIs and verify all contact information). If you plan on transporting animals, check out our Help Center articles on obtaining USDA certification – it’s easy and affordable to obtain. Beyond that, anything else you bring to the table is a bonus! Helpful tip - our customers value professionalism and experience above all else. Be sure to emphasize these qualities in your profile and use each successful transport to capture favorable customer reviews!"
          }
        }, {
          "@type": "Question",
          "name": "How do I get paid?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The shipper pays you directly for the transport. CitizenShipper is not involved in and does not mediate any aspects of the payment. When you bid on a shipment and win, you arrange the terms of payment with the shipper. Typically, the payment is made upon delivery, but you can request money upfront for expenditures such as gas or lodging. It is important to specify exactly what you expect in terms of payment before accepting the customer’s 'book shipment' request. You can use any form of payment you want, as long as it is agreed to by both you and the customer. However, we do recommend using disputable forms of payment such as a credit card or PayPal."
          }
        }, {
          "@type": "Question",
          "name": "How can I tell if there are shipments in my area?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Once you sign up, your recommended shipments tab should display all the shipments listed that match your category and location settings. In case you wish to browse shipments in a different location, you can update this in your notification settings to specify which states, cities, or regions you want to cover, or use our search tool. When shipments are listed in the areas specified, we’ll send you a notification by text or email. Hundreds of listings go up each week, so if you’re in a populated area, you should be able to find plenty of shipments."
          }
        }, {
          "@type": "Question",
          "name": "Do I have any costs?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "It is important to include any costs you might incur during your transport into the initial bid you provide the customer. Examples of these costs include gas, lodging, meals, vehicle wear and tear – whatever you feel needs to be compensated for as part of the transport. In addition, CitizenShipper is a subscription-based platform but we do offer a three-month free trial plus a 30-day money-back guarantee – in essence, four months of free subscription. We do this so you are not burdened with any fees before you start turning a profit. Once the trial period is up, the subscription fee is $29.99 per month. We feel this amount is reasonable for the use of the platform, its resources and features that help drive your business and because it brings the business to you without any effort on your part. There are no additional activation or cancellation costs associated with this service. You can pause, resume, or cancel your subscription at any time."
          }
        }, {
          "@type": "Question",
          "name": "Is there any Driver education or support available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, CitizenShipper has a robust Driver Onboarding team that offers FREE 1:1 onboarding sessions, building business workshops, tutorials and numerous articles and education on our site’s Help Center. We are committed to helping drivers in our community achieve success and are always available to help."
          }
        }]
      }
`,
    }}
  />
)

export const petTransporationFaqSchema = (
  <script
    key="pet-transportation-faq-schema"
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [{
      "@type": "Question",
      "name": "Is it really free to list a pet shipment?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. There are no listing fees involved. You don't pay a dime before negotiating the cost of transport with the driver you choose to hire."
      }
    }, {
      "@type": "Question",
      "name": "How much does it cost to transport a pet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The cost varies, depending mostly on the mileage. When drivers send in their quotes, it'll be up to you to choose whatever sounds reasonable. Typical rates are between $.5 and $1.60 per mile, but this can skew higher on shorter trips. Some shipments are more expensive than others: puppies, for example, require more attention so they often cost extra to transport."
      }
    }, {
      "@type": "Question",
      "name": "How stressful is the journey for a pet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "For most animals, the stress of road transportation is kept to a minimum. For animals with elevated anxiety issues, please consult your veterinarian. If you want special attention paid to your pet, that’s usually doable. Each driver offers a slightly different level of service — with a little extra effort, you can find people with animal care degrees able to provide your pet with the greatest level of comfort available. "
      }
    }, {
      "@type": "Question",
      "name": "How should I prepare my pet for the move?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Different animals have different requirements, but in general you should try to provide: <br> <p>
        <ul>
        <li>Basic car training: Try to make sure your pet is used to riding in a car and spending time inside a carrier crate.</li>
        <li>Health certificate: Take the pet in for a check-up so the vet can verify they’re fit to travel.</li>
        <li>Food supply: Pack their favorite snacks, but try not to feed the pet for 2-3 hours before they hit the road</li>
        <li>Extras: If you can, also pack their favorite toys or blankets to keep them calm and comfortable.</li>
        </ul>
        </p>"
      }
    }]
  }`,
    }}
  />
)

export const motorcycleFaqSchema = (
  <script
    key="motorycycle-faq-schema"
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: `
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
          "@type": "Question",
          "name": "How much does motorcycle shipping cost?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The average winning bid is about 3 cents per mile, but quotes do vary. Short distances typically charge more than longer trips. Weight and bulk of the shipment also affect the cost. Affordability plays an important role in the carrier selection process, but it’s not the only one. Most shippers take several other factors into account when deciding with carrier to use. The key is to be comfortable with your choice."
          }
        }, {
          "@type": "Question",
          "name": "How can I determine what kind of trailer/truck/gear a carrier has?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Carriers who specialize in motorcycle shipping usually list this information on their profile pages. Be sure to check out the profile of any carrier you are considering. If you don’t see the information listed, make a point of messaging a prospective carrier directly to obtain it."
          }
        }, {
          "@type": "Question",
          "name": "How do I prepare a motorcycle for shipping?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Some general guidelines include draining the gas from the tank and detaching all non-essentials from the motorcycle. We’ve put together these helpful <a href=”https://citizenshipper.com/blog/motorcycle-shipping-tips/”>shipping tips</a> to provide some additional direction."
          }
        }]
      }
    `,
    }}
  />
)

export const catTransportationSchema = (
  <>
    <script
      key="cat-transportation"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "Cat Shipping Service",
    "image": "https://citizenshipper.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fnico-mica%402x.9d472466.webp&w=640&q=75",
    "description": "Cat Shipping Service that delivers anywhere within the US.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "7879",
      "reviewCount": "",
      "bestRating": "5",
      "worstRating": "1",
      "itemReviewed": {
        "@type": "Service",
        "url": "https://citizenshipper.com/cat-transportation",
        "name": "Cat Shipping Service"
      },
      "name": "Cat Shipping Service"
    },
  "offers": {
        "@type": "AggregateOffer",
        "lowPrice": "245",
        "priceCurrency": "USD"
      },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Heather Maring"
        },
        "description": "Used Citizenshippper to ship a kitten to St Paul MN and used Hunter D and it was a great experience.",
        "url": "https://goo.gl/maps/Nt9p7Xa4emTJBjD48",
        "publisher": {
          "@type": "Organization",
          "name": "Google"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "J Flor"
        },
        "description": "This was my first experience with Citizenshipper and it was a great sucess.  Our cat arrived in great shape and was fairly relaxed.  We discussed the number of daily updates we wanted when she was collected and received most of those in a timely manner.  The process went smoothly from start to finish.",
        "url": "https://goo.gl/maps/yJ8JAydEvoXhaj6q7",
        "publisher": {
          "@type": "Organization",
          "name": "Google"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Joan Symons"
        },
        "description": "I wasn't sure what to do when I decided to get a pair of Kittens. The owner lived in Washington and I lived far south in Oregon near the Calif border. I knew I couldn't make the drive so I googled pet transport and this company came up in the listing. I put in my request and within an hour had a lot of transporters to choose from. Very simple, easy process and had locked in travel arrangements within a very short time. Thank you so much for being there.",
        "url": "https://trstp.lt/i1PS0PUti",
        "publisher": {
          "@type": "Organization",
          "name": "TrustPilot"
        }
      }
    ]
    }`,
      }}
    />
    <script
      key="cat-transportation-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },{
            "@type": "ListItem",
            "position": 2,
            "name": "Cat Shipping"
          }]
        }`,
      }}
    />
  </>
)

export const dogTransportationSchema = (
  <>
    <script
      key="dog-transportation-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Dog Shipping Service",
          "image": "https://citizenshipper.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fnico-mica%402x.9d472466.webp&w=640&q=75",
          "description": "Dog transport that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/dog-transportation",
              "name": "Dog Shipping Service"
            },
            "name": "Dog Shipping Service"
          },
        "offers": {
              "@type": "AggregateOffer",
              "lowPrice": "245",
              "priceCurrency": "USD"
            },
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Stephanie Daza"
              },
              "description": "I definitely recommend this site. I was hesitant at first because I had never heard of this site, but I did research and it seemed legit. I decided to give it a try and created my first post looking for my dog to be transported from Grand Island, NE to Fresno, CA. Within a couple of hours, I started to receive multiple bids. I picked my driver based on his ratings, but he also happened to be my lowest bid. Many drivers are also willing to negotiate prices as well. Overall, the site was very easy to use. You post the job, drivers bid, and then you decided who you want to pick to do the job. My dog arrived safely to Fresno, CA and my driver did not require any payment until the completion of the transportation.",
              "url": "https://goo.gl/maps/5GsxL9Fdtbz1yLWz9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Kelli E Hardee"
              },
              "description": "Quick responses. Great prices. Love the ratings and reviews. Im so happy I have used them 4 times now for transporting my puppies and dogs.",
              "url": "https://goo.gl/maps/uTt5rzocvAkM6utm7",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Linda"
              },
              "description": "My little girl dog is usually afraid of strange men but she took right to our driver. He was kind and went out of his way to allay our fears. He made sure to send pictures a couple times a day. I will gladly use him again if we ever need her transported again!",
              "url": "https://trstp.lt/DYLfJw3xk",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="dog-transportation-schema-"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Dog Shipping"
          }
                      ]
        }`,
      }}
    />
  </>
)

export const vehicleTransportationSchema = (
  <>
    <script
      key="vehicle-transportation-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Vehicle Transport Service",
          "image": "https://citizenshipper.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fvehicle-hero-first.df9f3562.webp&w=640&q=75",
          "description": "Vehicle Transport Service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/vehicle-transportation",
              "name": "Vehicle Shipping Service"
            },
            "name": "Vehicle Transport Service"
          },
        
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Monika"
              },
              "description": "A friend of mine gave me the link to citizen shipper and it came I'm very handy, my car was stuck in South Carolina and I used citizen shipper to get my car back to Chicago, I will definitely pass along this wonderful company to everyone, highly recommend!",
              "url": "https://www.trustpilot.com/reviews/5567b8a20000ff0002e967ff",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Francisco Calderon"
              },
              "description": "CitizenShipper is a great site and did an amazing job to help me get a car shipped in short notice after my first shipper didn’t show up they were quick to get me a quote and get my vehicle shipped with a great price as well!!",
              "url": "https://www.trustpilot.com/reviews/618bfe9bfb38891f5f07b5d8",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "DocJoe"
              },
              "description": "Easy to deal with; got several shippers responding to my request to ship a car; some were very compeetetive in price; chose one, and he was also easy to deal with, dependable, and did exactly what he promised. I highly recommend CitizenShipper.",
              "url": "https://www.trustpilot.com/reviews/6166038d75069a4da4837cb5",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            }
          ]
          }
        `,
      }}
    />
    <script
      key="vehicle-transportation-schema-"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Vehicle Transport"
          }
                      ]
        }`,
      }}
    />
  </>
)

export const apartmentMovesSchema = (
  <>
    <script
      key="apartment-moves-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Moving Service",
          "image": "https://citizenshipper.com/_next/image?url=https%3A%2F%2Fa-us.storyblok.com%2Ff%2F1002522%2F1388x1714%2F9f4e2aa7e9%2Fapartment-hero.webp&w=2048&q=75",
          "description": "Moving service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/apartment-moves",
              "name": "Moving Service"
            },
            "name": "Moving Service"
          },
        
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Michael Grady Sr."
              },
              "description": "CitizenShipper was great and very easy to use. It was my first time and everything went very smoothly. Chris was absolutely great. Communication was awesome. Kept me updated all the way here. Very polite and will definitely do business with him again. I don’t ship much but he will be my go to shipper for any future needs. Did exactly what he said he was going to do. Thank you Chris. Would highly recommend to anyone needing anything shipped.",
              "url": "https://goo.gl/maps/yM5P5AnCPen86Use8",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Michelle Stook"
              },
              "description": "I was super skeptical about this at first but I had a feeling my driver was a great guy. I was so pleased with the service and how fair and respectful and easy it all was. Would 10/10 recommend.",
              "url": "https://goo.gl/maps/emUAJy1RxvWLS1Ji8",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Laurie Dilday"
              },
              "description": "I highly recommend CitizenShipper. I used them and got A+ service. What a great experience.",
              "url": "https://goo.gl/maps/zxmksCK94PtnqGyD9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="apartment-moves-list"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Apartment Moves"
          }
                      ]
        }`,
      }}
    />
  </>
)

export const carShippingSchema = (
  <>
    <script
      key="car-shipping-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": "Cat Shipping Service",
    "image": "https://citizenshipper.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fnico-mica%402x.9d472466.webp&w=640&q=75",
    "description": "Cat Shipping Service that delivers anywhere within the US.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "7879",
      "reviewCount": "",
      "bestRating": "5",
      "worstRating": "1",
      "itemReviewed": {
        "@type": "Service",
        "url": "https://citizenshipper.com/cat-transportation",
        "name": "Cat Shipping Service"
      },
      "name": "Cat Shipping Service"
    },
  "offers": {
        "@type": "AggregateOffer",
        "lowPrice": "245",
        "priceCurrency": "USD"
      },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Heather Maring"
        },
        "description": "Used Citizenshippper to ship a kitten to St Paul MN and used Hunter D and it was a great experience.",
        "url": "https://goo.gl/maps/Nt9p7Xa4emTJBjD48",
        "publisher": {
          "@type": "Organization",
          "name": "Google"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "J Flor"
        },
        "description": "This was my first experience with Citizenshipper and it was a great sucess.  Our cat arrived in great shape and was fairly relaxed.  We discussed the number of daily updates we wanted when she was collected and received most of those in a timely manner.  The process went smoothly from start to finish.",
        "url": "https://goo.gl/maps/yJ8JAydEvoXhaj6q7",
        "publisher": {
          "@type": "Organization",
          "name": "Google"
        }
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Joan Symons"
        },
        "description": "I wasn't sure what to do when I decided to get a pair of Kittens. The owner lived in Washington and I lived far south in Oregon near the Calif border. I knew I couldn't make the drive so I googled pet transport and this company came up in the listing. I put in my request and within an hour had a lot of transporters to choose from. Very simple, easy process and had locked in travel arrangements within a very short time. Thank you so much for being there.",
        "url": "https://trstp.lt/i1PS0PUti",
        "publisher": {
          "@type": "Organization",
          "name": "TrustPilot"
        }
      }
    ]
    }`,
      }}
    />
    <script
      key="cat-transportation-faq-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },{
            "@type": "ListItem",
            "position": 2,
            "name": "Cat Shipping"
          }]
        }`,
      }}
    />
  </>
)
export const boatTransportationSchema = (
  <>
    <script
      key="boat-transportation-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Boat Shipping Service",
          "image": "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg",
          "description": "Boat shipping service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/boat-transportation",
              "name": "Boat Shipping Service"
            },
            "name": "Boat Shipping Service"
          },
        
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Peyton McWilliams"
              },
              "description": "Great people delivered a 19ft boat from Indiana to Texas for us in 2 days. Would highly recommend them.",
              "url": "https://goo.gl/maps/ahQRvYC5JXgbqakU6",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Daniel Cyr"
              },
              "description": "Was a great company to do business with they got my Boat to me fast. You get bids from different haulers. I got a lower bid but decided to go with luxury transport services they were professional to me on the phone The low price ain't always the best",
              "url": "https://trstp.lt/OeaA4uAp_",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Joe"
              },
              "description": "Delivered a boat and it arrived in good condition",
              "url": "https://trstp.lt/gQ1qB5wm5",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            }
          ]
          }
        `,
      }}
    />
    <script
      key="boat-transportation-list"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: ` {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Boat Transport"
          }
                      ]
        }`,
      }}
    />
  </>
)

export const petShippingSchema = (
  <>
    <script
      key="pet-shipping-product-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Local Pet Shipping Service",
          "image": "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg",
          "description": "Local pet shipping service delivering to any city in the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/pet-shipping/all-cities",
              "name": "Local Pet Shipping Service"
            },
            "name": "Local Pet Shipping Service"
          },
        "offers": {
              "@type": "AggregateOffer",
              "lowPrice": "245",
              "priceCurrency": "USD"
            },
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Gabe Horton"
              },
              "description": "Great service when you need to find the best value for transporting pets!",
              "url": "https://goo.gl/maps/vjGueEpGe124fmQP9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Jenny Bouchard"
              },
              "description": "This is a wonderful service that takes exceptional care of your pet and can work even within short notice!",
              "url": "https://goo.gl/maps/VWRicw8t5UHCSHQbA",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Heather Maring"
              },
              "description": "Used Citizenshippper to ship a kitten to St Paul MN and used Hunter D and it was a great experience.",
              "url": "https://goo.gl/maps/Nt9p7Xa4emTJBjD48",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="pet-shipping-breadcrumb-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `    {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Pet Transportation",
              "item": "https://citizenshipper.com/pet-transportation"
            },
           {
              "@type": "ListItem",
              "position": 2,
              "name": "All Cities",
              "item": "https://citizenshipper.com/pet-shipping/all-cities"
          }
          ]
          }`,
      }}
    />
  </>
)

export const boatShippingSchema = () => (
  <>
    <script
      key="boat-shipping-breadcrumb-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `    {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "item": "https://citizenshipper.com/boat-transportation",
              "name": "Boat Transportation",
              "position": 1
            },
            {
              "@type": "ListItem",
              "item": "https://citizenshipper.com/boat-transportation/all-cities",
              "name": "Boat Transportation - All Cities",
              "position": 2
            }
          ]
          }`,
      }}
    />
  </>
)

export const boatShippingCitySchema = (city, state, abbrev) => (
  <script
    key="boat-transportation-city-faq-schema"
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: `{
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "item": "https://citizenshipper.com/boat-transportation",
                "name": "Boat Transportation",
                "position": 1
              },
              {
                "@type": "ListItem",
                "item": "https://citizenshipper.com/boat-transportation/all-cities",
                "name": "Boat Transportation - All Cities",
                "position": 2
              },
              {
                "@type": "ListItem",
                "item": https://citizenshipper.com/boat-transportation/${state}/${city},
                "name": ${abbrev} Boat Shipping",
                "position": 3
              }
            ]
          
          }`,
    }}
  />
)
export const motorcycleTransportationSchema = (
  <>
    <script
      key="motorcycle-transportation-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Motorcycle Shipping Service",
          "image": "https://citizenshipper.com/_next/image?url=https%3A%2F%2Fa-us.storyblok.com%2Ff%2F1002522%2F1388x1714%2F6746f79c54%2Fmotorcycle-hero.webp&w=2048&q=75",
          "description": "Motorcycle shipping service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/motorcycle-transportation",
              "name": "Motorcycle Shipping Service"
            },
            "name": "Motorcycle Shipping Service"
          },
        
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "The Warden"
              },
              "description": "These guys were very good quick and communicated well. I got my bike home safe and I knew how soon I would get it. I will definitely use them again. The driver had no issue with me contacting him constantly to see where he was and how long it would take him to get to me. Citizenshipper has a great price and they even got me into a closed trailer which made me real feel really safe and not concerned about my motorcycle. They kept in constant contact and even the dispatching office was quick with getting back to me with any questions. I guess my issue was I've never done this before so I was very concerned with a stranger handling my motorcycle but they were good and quick and kept me comfortable with the insurance and everything. Way2go citizenshipper and I will definitely tell others about you and use you again if I need.",
              "url": "https://goo.gl/maps/dxtuP5ET7K1oVzdY9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Damian Mówiński"
              },
              "description": "Very satisfied using this platform. Many drivers are bidding so the price is low and you can pick final driver with best reviews. Totally recommend it. It’s so easy and it works great. It’s First time I used it but definitely not the last. I’m happy having mi motorcycle delivered safely!",
              "url": "https://goo.gl/maps/Da2cz25PQAqf9Yai9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Bob"
              },
              "description": "This was a very easy website to use and received many bids to move my motorcycle within an hour. Really happy with the layout in ease of use.",
              "url": "https://trstp.lt/x2mtcdC01",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="motorcycle-transportation"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Motorcycle Shipping"
          }
                      ]
        }`,
      }}
    />
  </>
)
export const rvTransportationSchema = (
  <>
    <script
      key="rv-transportation-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "RV Transport Service",
          "image": "https://citizenshipper.com/_next/image?url=https%3A%2F%2Fa-us.storyblok.com%2Ff%2F1002522%2F1388x2013%2F3adb2f5d84%2Frv-hero.webp&w=2048&q=75",
          "description": "RV transport service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/rv-transport",
              "name": "RV Transport Service"
            },
            "name": "RV Transport Service"
          },
        
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Jake Greenwell"
              },
              "description": "Received several quotes in a short amount of time. Everything worked out great.",
              "url": "https://goo.gl/maps/HAG14JTwoaXKRmzq7",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Jen B"
              },
              "description": "Easy to use and very quick response time. Found exactly what I needed!  Highly recommend!",
              "url": "https://goo.gl/maps/bsMuQjJpApqtuSUw6",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Laurie Dilday"
              },
              "description": "I highly recommend CitizenShipper. I used them and got A+ service. What a great experience.",
              "url": "https://goo.gl/maps/zxmksCK94PtnqGyD9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="rv-transportation"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "RV Transport"
          }
                      ]
        }`,
      }}
    />
  </>
)
export const equipmentShippingSchema = (
  <>
    <script
      key="equipment-shipping"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Equipment Shipping Service",
          "image": "https://citizenshipper.com/_next/image?url=https%3A%2F%2Fa-us.storyblok.com%2Ff%2F1002522%2F1388x1714%2F40872aa42b%2Fequipment-hero.webp&w=2048&q=75",
          "description": "Equipment shipping service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/equipment-shipping",
              "name": "Equipment Shipping Service"
            },
            "name": "Equipment Shipping Service"
          },
        
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Kasandra Kawahara"
              },
              "description": "They were fair priced and the website was very easy to use. I don't know what I would have done if I wouldn't have found their website. They have thorough back ground on their drivers and you're able to read every review that's been posted. I recommend using them for any kind of shipment.",
              "url": "https://goo.gl/maps/XjACBHHXzsEsoaVU6",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Laurie Dilday"
              },
              "description": "I highly recommend CitizenShipper. I used them and got A+ service. What a great experience.",
              "url": "https://goo.gl/maps/zxmksCK94PtnqGyD9",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Mary"
              },
              "description": "Using Citizen Shipper turned out to be a great experience for my transport needs. After filling out a form with Citizen Shipper, bids came in fairly quickly. I was able to read verified reviews of drivers and choose one. Her great reviews were 100% accurate and price was more than fair. I’m very glad I used Citizen Shipper and recommend it highly",
              "url": "https://trstp.lt/CUbLG61p7",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="equipment-shipping-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: ` {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Equipment Shipping"
          }
                      ]
        }`,
      }}
    />
  </>
)
export const householdShippingSchema = (
  <>
    <script
      key="household-shipping"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "Household Goods Shipping Service",
          "image": "https://citizenshipper.com/_next/image?url=https%3A%2F%2Fa-us.storyblok.com%2Ff%2F1002522%2F1412x1668%2F0bcc7005aa%2Fhousehold-hero.webp&w=2048&q=75",
          "description": "Household Goods Shipping Service that delivers anywhere within the US.",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "7879",
            "reviewCount": "",
            "bestRating": "5",
            "worstRating": "1",
            "itemReviewed": {
              "@type": "Service",
              "url": "https://citizenshipper.com/shipping-furniture",
              "name": "Household Goods Shipping Service"
            },
            "name": "Household Goods Shipping Service"
          },
          
          "review": [
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "april market"
              },
              "description": "Great service helped me get my furnature piece I bought  to my house",
              "url": "https://goo.gl/maps/ETiqqwDvytqLnP9X6",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Jake Greenwell"
              },
              "description": "Received several quotes in a short amount of time. Everything worked out great.",
              "url": "https://goo.gl/maps/HAG14JTwoaXKRmzq7",
              "publisher": {
                "@type": "Organization",
                "name": "Google"
              }
            },
            {
              "@type": "Review",
              "author": {
                "@type": "Person",
                "name": "Fredd Bloggs"
              },
              "description": "I was able to get a good deal on shipping some furniture in a relatively short time. The transporter showed up in a clean moving box truck, my items were well protected and they were very prompt and professional.",
              "url": "https://trstp.lt/tiJYN9t75",
              "publisher": {
                "@type": "Organization",
                "name": "TrustPilot"
              }
            }
          ]
          }`,
      }}
    />
    <script
      key="household-shipping-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
                      {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://citizenshipper.com"
          },
                            {
            "@type": "ListItem",
            "position": 2,
            "name": "Household Goods Shipping"
          }
                      ]
        }`,
      }}
    />
  </>
)

export const breedersSchema = (
  <>
    <script
      key="breeders-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `    {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Breeders",
            "item": "https://citizenshipper.com/breeders"
          }]
        }`,
      }}
    />
  </>
)

export const motorycycleCarriersSchema = (
  <>
    <script
      key="motorcycle-carriers-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `    {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "New Drivers",
            "item": "https://citizenshipper.com/new-drivers"
          },
         {
            "@type": "ListItem",
            "position": 2,
            "name": "Motorcycle Transporters",
            "item": "https://citizenshipper.com/motorcycle-carriers"
          }]
        }`,
      }}
    />
  </>
)

export const aboutUsSchema = (
  <>
    <script
      key="about-us-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "https://schema.org/",
          "@type": "AboutPage",
          "name": "About CitizenShipper",
          "description": "Learn about CitizenShipper's history, mission, and values.",
          "url": "https://citizenshipper.com/about-us",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@id": "https://citizenshipper.com/about-us",
                "name": "About Us"
              }
            }]
          },
          "mainEntity": {
            "@type": "Organization",
            "name": "Citizenshipper",
            "url": "https://citizenshipper.com/",
            "logo": {
              "@type": "ImageObject",
              "url": "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg"
            },
            "foundingDate": "2008",
            "founder": {
              "@type": "Person",
              "name": "Richard Obousy"
            },
            "description": "CitizenShipper is the safest, simplest way to transport anything, anywhere in the US. Connect with a fleet of screened drivers for a stress-free experience.",
            "address": {
              "@type": "PostalAddress",
              "postalCode": "78702",
              "streetAddress": "701 Tillery Street Unit 12-1249",
              "addressCountry": "US",
              "addressRegion": "Texas",
              "addressLocality": "Austin"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "email": "support@citizenshipper.com"
            },
            "sameAs": [
               "https://www.facebook.com/CitizenShipperLLC",
               "https://www.instagram.com/citizenshipper/",
               "https://www.linkedin.com/company/citizenshipper",
               "https://www.youtube.com/@citizenshipper",
               "https://en.wikipedia.org/wiki/CitizenShipper",
               "https://citizenshipper.com/",
               "https://x.com/CitizenShipper",
               "https://www.tiktok.com/@citizen.shipper",
               "https://www.pinterest.com/citizenshipper/"
            ]
          },
          "image": {
            "@type": "ImageObject",
            "url": "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg",
            "height": "auto",
            "width": "auto"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Citizenshipper",
            "logo": {
              "@type": "ImageObject",
              "url": "https://citizenshipper.com/_next/static/media/cs-logo-desktop.f18ce186.svg"
            }
          }
        }
        `,
      }}
    />
  </>
)

export const boatTransportationCityMainSchema = ({
  blokReviews,
  formattedCity,
  boatUrl,
}) => ({
  "@context": "http://schema.org",
  "@type": "Product",
  name: `${formattedCity} Boat Transport Service`,
  image:
    "https://dxy7kbcx3zqmq.cloudfront.net/citizenshipper-boat-transportation.webp",
  description: `Boat transport services from and to ${formattedCity} in the USA.`,
  offers: {
    "@type": "AggregateOffer",
    lowPrice: "199",
    priceCurrency: "USD",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    bestRating: "5",
    ratingValue: blokReviews?.averageRating,
    reviewCount: blokReviews?.totalReviews,
    worstRating: "1",
    itemReviewed: {
      "@type": "Service",
      url: boatUrl,
      name: `${formattedCity} Boat Transport Service`,
    },
    name: `${formattedCity} Boat Transport Service`,
  },
  review: [
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Peyton McWilliams",
      },
      datePublished: "2022",
      reviewBody:
        "Great people delivered a 19ft boat from Indiana to Texas for us in 2 days. Would highly recommend them.",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://maps.app.goo.gl/8688B76DKSg82PZz7",
      publisher: {
        "@type": "Organization",
        name: "Google",
      },
    },
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Marjory",
      },
      datePublished: "2024-08-20",
      reviewBody:
        "I have had a good experience twice now booking, one to transport a boat and once my dog. Previous reviews were helpful and accurate and I was able to find a trustworthy shipper both times. I have great confidence in CitizenShipper and have shared it with my friends.",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url:
        "https://www.consumeraffairs.com/pets/citizenshipper.html?page=1#sort=top_reviews&city=Sandy&state=UT",
      publisher: {
        "@type": "Organization",
        name: "ConsumerAffairs",
      },
    },
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "James Armour",
      },
      datePublished: "2024-10-17",
      reviewBody:
        "Site is very easy to use. They screen anyone that will bid on a request. I was looking to have my boat shipped about 500 miles. Once I set everything up I had many quotes/bids within an hour. The driver I chose (Ruslan Hernandez) was outstanding. Fair pricing and great communication through the whole process. Highly recommend.",
      name: "Site is very easy to use",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://www.trustpilot.com/reviews/67128668a2ff0dd04279085d",
      publisher: {
        "@type": "Organization",
        name: "Trustpilot",
      },
    },
  ],
})

export const boatTransportationMainSchema = ({ blokReviews }) => ({
  "@context": "http://schema.org",
  "@type": "Product",
  name: "Boat Transport Service",
  image:
    "https://dxy7kbcx3zqmq.cloudfront.net/citizenshipper-boat-transportation.webp",
  description: "Boat transport services across the USA.",
  offers: {
    "@type": "AggregateOffer",
    lowPrice: "199",
    priceCurrency: "USD",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    bestRating: "5",
    ratingValue: blokReviews?.averageRating,
    reviewCount: blokReviews?.totalReviews,
    worstRating: "1",
    itemReviewed: {
      "@type": "Service",
      url: "https://citizenshipper.com/boat-transportation",
      name: "Boat Transport Service",
    },
    name: "Boat Transport Service",
  },
  review: [
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Peyton McWilliams",
      },
      datePublished: "2022",
      reviewBody:
        "Great people delivered a 19ft boat from Indiana to Texas for us in 2 days. Would highly recommend them.",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://maps.app.goo.gl/8688B76DKSg82PZz7",
      publisher: {
        "@type": "Organization",
        name: "Google",
      },
    },
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Marjory",
      },
      datePublished: "2024-08-20",
      reviewBody:
        "I have had a good experience twice now booking, one to transport a boat and once my dog. Previous reviews were helpful and accurate and I was able to find a trustworthy shipper both times. I have great confidence in CitizenShipper and have shared it with my friends.",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url:
        "https://www.consumeraffairs.com/pets/citizenshipper.html?page=1#sort=top_reviews&city=Sandy&state=UT",
      publisher: {
        "@type": "Organization",
        name: "ConsumerAffairs",
      },
    },
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "James Armour",
      },
      datePublished: "2024-10-17",
      reviewBody:
        "Site is very easy to use. They screen anyone that will bid on a request. I was looking to have my boat shipped about 500 miles. Once I set everything up I had many quotes/bids within an hour. The driver I chose (Ruslan Hernandez) was outstanding. Fair pricing and great communication through the whole process. Highly recommend.",
      name: "Site is very easy to use",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://www.trustpilot.com/reviews/67128668a2ff0dd04279085d",
      publisher: {
        "@type": "Organization",
        name: "Trustpilot",
      },
    },
  ],
})

export const vehicleTransportationCityMainSchema = ({
  blokReviews,
  formattedCity,
  vehicleUrl,
}) => ({
  "@context": "http://schema.org",
  "@type": "Product",
  name: `${formattedCity} Car and Other Vehicle Shipping Service`,
  image:
    "https://dxy7kbcx3zqmq.cloudfront.net/citizenshipper-boat-transportation.webp",
  description: `Car and other vehicle shipping services from and to ${formattedCity} in the USA.`,
  offers: {
    "@type": "AggregateOffer",
    lowPrice: "199",
    priceCurrency: "USD",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    bestRating: "5",
    ratingValue: blokReviews?.averageRating,
    reviewCount: blokReviews?.totalReviews,
    worstRating: "1",
    itemReviewed: {
      "@type": "Service",
      url: vehicleUrl,
      name: `${formattedCity} Car and Other Vehicle Transport Service`,
    },
    name: `${formattedCity} Car and Other Vehicle Transport Service`,
  },
  review: [
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Vidro",
      },
      datePublished: "2025-02-05",
      reviewBody:
        "Highly recommended for your vehicle shipping needs. Mr. Hernandez courtesy and customer service is second to none.",
      name: "Highly recommended for your vehicle…",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://www.trustpilot.com/reviews/67a29b2037929da771965333",
      publisher: {
        "@type": "Organization",
        name: "Trustpilot",
      },
    },
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Melanie Covington",
      },
      datePublished: "2023-12-10",
      reviewBody:
        "Patricia who transported my car and pet from Texas to South l Carolina was professional , kind to my pet and most importantly both arrived on the stated delivery date in excellent condition. She is truth worthy and sent me updates and photos multiple times a day on the journey!",
      name: "Patricia who transported my car and pet…",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://www.trustpilot.com/reviews/6575fd3dde402fdd0af6e05d",
      publisher: {
        "@type": "Organization",
        name: "Trustpilot",
      },
    },
    {
      "@type": "Review",
      author: {
        "@type": "Person",
        name: "Jacquelyn",
      },
      datePublished: "2024-04-04",
      reviewBody:
        "Great experience booking cross country transport for my car and dog!",
      name: "Would def recommend",
      reviewRating: {
        "@type": "Rating",
        bestRating: "5",
        ratingValue: "5",
        worstRating: "1",
      },
      url: "https://www.trustpilot.com/users/660e191354ed3f0012e1a78c",
      publisher: {
        "@type": "Organization",
        name: "Trustpilot",
      },
    },
  ],
})
export const vehicleShippingSchema = () => (
  <>
    <script
      key="vehicle-shipping-breadcrumb-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `    {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "item": "https://citizenshipper.com/vehicle-transportation",
              "name": "Vehicle Transportation",
              "position": 1
            },
            {
              "@type": "ListItem",
              "item": "https://citizenshipper.com/vehicle-transportation/all-cities",
              "name": "Vehicle Transportation - All Cities",
              "position": 2
            }
          ]
          }`,
      }}
    />
  </>
)
